export default __webpack_public_path__ + "static/tag-do-4-dark-93f57c96c6ed93016adc2bf62e01336d679fa7caa88b8fdecfb56478a1efa561.png";